import { useEffect, useRef, useState } from "react";
import { IoMdAdd } from "react-icons/io";
import { MdArrowDropDown } from "react-icons/md";
import ContentModal from "./ContentModal";

const contentTypes = ["video", "material"];

function DropdownButton({ handleAddModal, refreshCourses }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [contentType, setContentType] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!isDropdownOpen) return undefined;
    const closeOnOutsideClick = (event) => {
      if (!dropdownRef.current?.contains(event.target))
        setIsDropdownOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsDropdownOpen(false);
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("mousedown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [isDropdownOpen]);

  const handleAddContentModalOpen = (type) => {
    setContentType(type);
    setIsAddModalOpen(true);
    setIsDropdownOpen(false);
  };

  const handleAddCourseModalClose = () => {
    setIsAddModalOpen(false);
    setContentType("");
    refreshCourses();
  };

  const openCourseModal = () => {
    setIsDropdownOpen(false);
    handleAddModal();
  };

  return (
    <div
      ref={dropdownRef}
      className={`relative flex w-full lg:w-auto ${isDropdownOpen ? "z-50" : ""}`}
    >
      {isDropdownOpen && (
        <button
          type="button"
          aria-label="Close add content menu"
          onClick={() => setIsDropdownOpen(false)}
          className="fixed inset-0 z-40 cursor-default bg-black/20 backdrop-blur-[1px]"
        />
      )}

      <div className="relative z-50 flex w-full overflow-hidden rounded-lg bg-[#2264E5] text-white shadow-sm ring-1 ring-blue-700/20 transition-shadow hover:shadow-md lg:w-auto">
        <button
          type="button"
          onClick={openCourseModal}
          className="flex min-h-[48px] flex-1 items-center justify-center gap-2 px-5 font-medium transition-colors hover:bg-blue-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white lg:flex-none"
        >
          <IoMdAdd size={22} aria-hidden="true" />
          Add Course
        </button>
        <button
          type="button"
          onClick={() => setIsDropdownOpen((open) => !open)}
          aria-label="Add course content"
          aria-haspopup="menu"
          aria-expanded={isDropdownOpen}
          className="flex min-h-[48px] min-w-[48px] items-center justify-center border-l border-white/30 transition-colors hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white"
        >
          <MdArrowDropDown
            size={28}
            aria-hidden="true"
            className={`transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : "rotate-0"}`}
          />
        </button>
      </div>

      <div
        role="menu"
        aria-hidden={!isDropdownOpen}
        className={`absolute right-0 top-full z-50 mt-2 w-56 origin-top-right overflow-hidden rounded-2xl border border-gray-200 bg-white p-2 text-gray-900 shadow-xl transition duration-150 ${isDropdownOpen ? "visible translate-y-0 scale-100 opacity-100" : "invisible -translate-y-1 scale-95 opacity-0 pointer-events-none"}`}
      >
        <div className="px-3 pb-2 pt-1">
          <p className="text-sm font-semibold">Add content</p>
          <p className="text-xs text-gray-500">Choose what to add to courses</p>
        </div>
        <div className="border-t border-gray-100 pt-1">
          {contentTypes.map((type) => (
            <button
              key={type}
              type="button"
              role="menuitem"
              onClick={() => handleAddContentModalOpen(type)}
              className="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm font-medium capitalize transition-colors hover:bg-blue-50 hover:text-[#2264E5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2264E5]/30"
            >
              {type}
              <IoMdAdd size={18} aria-hidden="true" />
            </button>
          ))}
        </div>
      </div>

      {isAddModalOpen && (
        <ContentModal
          isModalOpen={isAddModalOpen}
          closeModal={handleAddCourseModalClose}
          type={contentType}
        />
      )}
    </div>
  );
}

export default DropdownButton;
